module.exports = __webpack_public_path__ + "img/zhengshu6.d350b717.png";